import React  from 'react';
import { useState } from 'react';
import Select from 'react-select';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '15px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    width: '230px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const CableContainerEdit = ({toggleVisibilityCable, isVisibleCable, cableData,
    handleCableSelectChange,cableTypeData, handleLineStyleSelectChange, contractorData,
    selectedContractor, handleChangeContractor, commentCable, commentTextAreaRefCable, handleCommentChangeCable,
    isLineDrawing, handleStartDrawing, handleStopDrawing, handleCableConstructSave, selectedCable,handleChangeCableSelect,
    selectedTypeCable,handleChangeCableType, rankCableData, handleChangeRankCable,selectedRankCable, reserve, setReserve, forwarding,
    setForwarding, polishingData, cassetteData, showCassetteCable, setShowCassetteCable, selectedPolishingPatch, setSelectedPolishingPatch,
    selectedCassetteModel, setSelectedCassetteModel, cassetteCableCount, setCassetteCableCount, patchCableCount, setPatchCableCount}) => {

  const [inputValue, setInputValue] = useState("");
  const [showUnknown, setShowUnknown] = useState(false);


  //      // Преобразуем данные кабелей в формат для react-select
 const options = cableData
  .filter(cable => cable.cableGroupId === 2 || cable.cableGroupId === 3) // фильтрация нужных групп
  .map(cable => ({
    value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
    label: cable.name,
    group: cable.cableGroupId === 3 ? "Воздушка" : "Подземка",
  }));


  // Группировка опций
  const groupedOptions = [
    {
      label: "Воздушка",
      options: options.filter(option => option.group === "Воздушка"),
    },
    {
      label: "Подземка",
      options: options.filter(option => option.group === "Подземка"),
    },
  ];

  





      
  return (
    <React.Fragment>
    <button onClick={toggleVisibilityCable} className={isVisibleCable ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleCable ? 'Кабель: скрыть' : 'Кабель: показать'}
    </button>
        {isVisibleCable && (                  
          <div className='divСommunicationsDrawer'>
             <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
             <label className='textTitleDrawer'>Оптоволокно</label>
             <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px"}}/>
                <div className="selectContainer">

              <div>
                {/* <label style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "5px",color: "#a3a3a3", fontSize: "14px" }}>
                <input 
                    type="checkbox" 
                    checked={showUnknown} 
                    onChange={() => setShowUnknown(prev => !prev)}
                />
                неизвестный кабель
            </label> */}

            <Select
                className="selectSearchDrawer"
                options={groupedOptions}
                inputValue={inputValue}
                styles={customStyles}
                value={options.find(option => option.value === selectedCable) || null}
                onInputChange={value => setInputValue(value)}
                onChange={selectedOption => {              
                    handleCableSelectChange(selectedOption);
                    handleChangeCableSelect(selectedOption);
                }}
                placeholder="Выберите кабель"
                isClearable
            />
        </div>
              
                

                {/* <select 
                    className="selectStyleDrawer" 
                    value={selectedCable}
                    onChange={(event) => {
                      handleCableSelectChange(event);
                      handleChangeCableSelect(event);
                    }}
                  >
                    <option value="">Выберите кабель</option> */}
                    
                    {/* Группа Воздушка */}
                    {/* <optgroup label="Воздушка">
                      {cableData
                        .filter(cable => cable.cableTypeId === 3)
                        .map(cable => (
                          <option 
                            key={cable.id} 
                            value={`${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`}
                          >
                            {cable.name}
                          </option>
                        ))}
                    </optgroup>
                     */}
                    {/* Группа Подземка */}
                    {/* <optgroup label="Подземка">
                      {cableData
                        .filter(cable => cable.cableTypeId === 2)
                        .map(cable => (
                          <option 
                            key={cable.id} 
                            value={`${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`}
                          >
                            {cable.name}
                          </option>
                        ))}
                    </optgroup>
                  </select> */}
                   
                </div>
                <div>
                <select className="selectStyleDrawer" value={selectedTypeCable || ""} style={{marginTop: '10px'}}
                       onChange={(event) => {
                        handleLineStyleSelectChange(event);
                        handleChangeCableType(event);
                      }}>
                      <option value="">Тип прокладки</option>
                        {cableTypeData.map(cableType => (

                          
                           <option key={cableType.id} value={`${cableType.id},${cableType.type},${cableType.kind}`}>{cableType.type}</option>
                        ))}
                    </select>  
                    <input
                      type='number'
                      className='textInput2EditingModal'
                      style={{marginLeft: '10px'}}
                      min={0}
                      placeholder='запас'
                      value={reserve}
                      onChange={(e) => setReserve(e.target.value)}
                    />
                    <label className='textTitleDrawer' style={{fontSize: '16px', marginLeft: '5px'}}>м.</label>
                    <br/>

                    {(() => {
                      const selectedId = parseInt(selectedTypeCable?.split(",")[0]);
                      return (!isNaN(selectedId) && selectedId !== 2 && selectedId !== 4 && selectedId !== 5) && (
                        <>
                        <label className="textTitleDrawer" style={{fontSize: '16px'}}>Проброс:</label>
                          <input
                            type="number"
                            className="textInput2EditingModal"
                            style={{ marginLeft: '10px' }}
                            value={forwarding}
                            min={0}
                            onChange={(e) => setForwarding(e.target.value)}
                          />
                          <label className="textTitleDrawer" style={{fontSize: '16px', marginLeft: '5px'}}>кол.</label>
                        </>
                      );
                    })()}


                    {(() => {
  const selectedId = parseInt(selectedTypeCable?.split(",")[0]);

  return !isNaN(selectedId) && selectedId !== 2 && (
    <>
      {/* Чекбокс "Кассета" */}
       <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px"}}/>
     <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          id="cassette"
          checked={showCassetteCable}
          onChange={() => setShowCassetteCable(!showCassetteCable)}
          style={{ margin: 0 }}
        />
        <label style={{ marginLeft: '5px', color: '#d6b220', fontSize: '16px'}} className="textTitleDrawer" >
          Кассета/Патчкорд
        </label>
      </div>

      {/* Блок с полями, если чекбокс активен */}
      {showCassetteCable && (  
        <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
        <label className="textTitleDrawer" style={{fontSize: '16px'}}>Кассета:</label>
           <select
            className="selectStyleDrawer"
            style={{ marginLeft: '10px', marginRight:'5px' }}
            value={selectedCassetteModel}
            onChange={(e) => setSelectedCassetteModel(e.target.value)}
          >
            <option value="">Модель</option>
            {cassetteData.map(option => (
              <option key={option.id} value={option.id}>{option.model}</option>
            ))}
          </select>


          <input
            type="number"
            placeholder="кол."
            style={{width: '60px'}}
            className="textInput2EditingModal"
            value={cassetteCableCount}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (value >= 0 || e.target.value === '') {
                setCassetteCableCount(e.target.value);
              }
            }}
          />
          <label className="textTitleDrawer" style={{fontSize: '16px', marginLeft:'5px'}}>шт.</label>
           <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px"}}/>
            <label className="textTitleDrawer" style={{fontSize: '16px'}}>Патчкорд:</label>
          <select
            className="selectStyleDrawer"
            style={{ marginLeft: '5px', marginRight:'5px'}}
            value={selectedPolishingPatch}
            onChange={(e) => setSelectedPolishingPatch(e.target.value)}
          >
            <option value="">Полировка</option>
            {polishingData.map(option => (
              <option key={option.id} value={option.id}>{option.type}</option>
            ))}
          </select>

          <input
            type="number"
            placeholder="кол."
            className="textInput2EditingModal"
            value={patchCableCount}
            style={{width: '60px'}}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (value >= 0 || e.target.value === '') {
                setPatchCableCount(e.target.value);
              }
            }}
          />
          <label className="textTitleDrawer" style={{fontSize: '16px', marginLeft:'5px'}}>шт.</label>
        </div>
      )}
    </>
  );
})()}
                {/* <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedContractor  || ""} onChange={handleChangeContractor} >
                   <option value="">Подрядчик</option>
                   {contractorData.map(contractor => (
                      <option key={contractor.id} value={`${contractor.id}`}>{contractor.name}</option>
                   ))}
                </select> 

                <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedRankCable  || ""} onChange={handleChangeRankCable} >
                   <option value="">Отоносится к узлам</option>
                   {rankCableData
                    .filter(rankCable => [3, 5, 6, 7, 8, 9].includes(rankCable.id))
                    .map(rankCable => (
                      <option key={rankCable.id} value={`${rankCable.id}`}>
                        {rankCable.name}
                      </option>
                    ))}
                </select>        */}

                <hr className="horizontalLineDrawer" style={{marginTop: "10px"}}/>
                                
                <textarea
                    className='areaDescriptionDrawer'
                    placeholder="Комментарий"
                    rows={3}
                    cols={44}
                    value={commentCable}
                    ref={commentTextAreaRefCable}
                    onChange={handleCommentChangeCable}
                />     
                </div>

                <div>
                  {!isLineDrawing && (
                    <button onClick={handleStartDrawing} className='buttonIsDrawingDrawer'>Начать</button>
                  )}
                  {isLineDrawing && (
                    <button onClick={handleStopDrawing} className='buttonIsDrawingDrawer2'>Завершить</button>
                  )}
                  <button onClick={handleCableConstructSave} className='buttonSaveDrawer'>Сохранить</button>             
                </div>
             </div>  
         )}

         
       </React.Fragment>
  );

  
};

export default CableContainerEdit;